export const parsePageNumberString = (pageNumberString: string): number => {
    if (pageNumberString) {
        return parseInt(pageNumberString);
    }
    return 1;
};
